import portalHeader from './header.vue'

export default {
  install (Vue, options = {}) {
    Vue.component('portal-header', portalHeader)
  }
}
